import { usePersonCareerAccess } from "@/pages/people/[pgaId]/person/_usePersonCareerAccess";
import { useParams } from "@/router";
import { PersonGovernanceTable } from "./_PersonGovernanceTable";

export default function PersonGovernanceRolesPage() {
  const { loaded, canViewPersonCareer } = usePersonCareerAccess();

  const { pgaId } = useParams("/people/:pgaId/career/governance-roles");

  if (!loaded || !canViewPersonCareer) {
    return null;
  }

  return <PersonGovernanceTable pgaId={pgaId} />;
}
